// reducer.js
import {
    DELETE_CUSTOMER_DEMO_REQUEST,
    DELETE_CUSTOMER_DEMO_SUCCESS,
    DELETE_CUSTOMER_DEMO_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
    isLoading: false,
    successMessage: null, // To store the success message
    error: null,
};

const updateCustomerDemoReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_CUSTOMER_DEMO_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
                successMessage: null,
            };
        case DELETE_CUSTOMER_DEMO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                successMessage: action.payload,
            };
        case DELETE_CUSTOMER_DEMO_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default updateCustomerDemoReducer;
